import * as React  from "react";
import {cs}        from "@Common/react/chain-services";

export const genBuscardV2 = ({session, specificationFields, specFieldOnChange, next}) => cs(
    ["specFieldDuplicates", ({}, next) => next([])],
    ["ordinalPosition", ({}, next) => next(2)],

    (({specFieldDuplicates, ordinalPosition}, next) => next(
        specificationFields.map( field => {
            // If no current value in field (default data, reorder, pending order), map default data specific to buildPath to fields by displayLabel
            if (!field.data) {
                switch( field.displayLabel.toLowerCase() ) {
                    case 'name':
                        field.data = session.data.agent?.agentNameFirst
                        +' '
                        + (session.data.agent?.agentNameMiddle?.length ? session.data.agent?.agentNameMiddle + ' ' : '')
                        + session.data.agent?.agentNameLast;
                        break;

                    case 'first name':
                        field.data = session.data.agent?.agentNameFirst;
                        break;

                    case 'last name':
                        field.data = session.data.agent?.agentNameLast;
                        break;

                    case 'address 1':
                        if( session.data.branch?.branchAddress2?.length > 1 ) {
                            field.data = session.data.branch?.branchAddress2;
                        } else {
                            field.data = session.data.branch?.branchAddress1;
                        }
                        break;

                    case 'address 2':
                        field.data = session.data.branch?.branchAddress2;
                        break;

                    case 'city, state, zip':
                        if( session.data.branch?.branchDisplay3?.length > 1 ) {
                            field.data = session.data.branch?.branchDisplay3;
                        } else {
                            field.data = session.data.branch?.branchCity + ", " + session.data.branch?.branchState + " " +  session.data.branch?.branchZip;
                        }
                        if( field.data.length < 6 ) field.data = '';
                        break;

                    case 'email':
                        field.data = session.data.agent?.agentEmail;
                        break;

                    case 'phone 1':
                        field.data = session.data.agent?.agentPhone1;
                        break;

                    case 'phone 2':
                        field.data = session.data.agent?.agentPhone2;
                        break;

                    default:
                        field.data = field.data;
                }
            }
            // update field with new ordinal position
            field.ordinal = ordinalPosition;
            specFieldDuplicates.push(field);
            ordinalPosition++;
        }
    ))),
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),
    ({specFieldDuplicates}) => next(specFieldDuplicates)
);